import { useState } from 'react'


import ReactPlayer from 'react-player'

import {
    IconPostPauseOutline,
    IconPostPlayOutline
} from 'assets/svg/sprite'
import {
    type CloudFrontCredentials,
    applyCloudFrontCookies
} from 'helpers/cloudfrontCookies'
import { formatVideoTime } from 'lib/dayjs'

import styles from './mediaItemVideo.module.scss'

interface Props {
    url: string
    thumbnail?: string
    cloudfront?: CloudFrontCredentials | null
    onPlaybackChange?: (state: {
        time: number
        duration: number
        playing: boolean
    }) => void
}
export const MediaItemVideo = ({
    url,
    thumbnail,
    cloudfront,
    onPlaybackChange
}: Props) => {
    const [mounted, setMounted] = useState(false)
    const [videoReady, setVideoReady] = useState(false)
    const [videoPlaying, setVideoPlaying] = useState(false)
    const [duration, setDuration] = useState(0)
    const [currentTime, setCurrentTime] = useState(0)
    const isProtectedHls =
        url.startsWith('https://video-cdn.allfans.com/') &&
        url.split('?')[0].endsWith('.m3u8')

    const toggleVideo = (event: React.MouseEvent) => {
        event.stopPropagation()

        if (!videoPlaying && isProtectedHls) {
            if (!cloudfront || !applyCloudFrontCookies(cloudfront)) {
                console.error(
                    '[MediaItemVideo] Missing or expired CloudFront credentials'
                )
                return
            }
        }

        if (!mounted) {
            setMounted(true)
            setVideoPlaying(true)
            return
        }

        setVideoPlaying(previous => !previous)
    }

    return (
        <div className={styles.wrapper}>
            {mounted && (
                <div className={styles.player}>
                    <ReactPlayer
                        width='100%'
                        height='100%'
                        url={url}
                        controls={false}
                        playing={videoPlaying}
                        progressInterval={250}
                        config={{
                            file: {
                                attributes: {
                                    preload: 'none',
                                    ...(isProtectedHls
                                        ? { crossOrigin: 'use-credentials' }
                                        : {})
                                },
                                hlsOptions: {
                                    xhrSetup: (xhr: XMLHttpRequest) => {
                                        xhr.withCredentials = isProtectedHls
                                    }
                                }
                            }
                        }}
                        onPlaying={() => {
                            setVideoReady(true)
                            setVideoPlaying(true)

                            onPlaybackChange?.({
                                time: currentTime,
                                duration,
                                playing: true
                            })
                        }}
                        onPause={() => {
                            setVideoPlaying(false)

                            onPlaybackChange?.({
                                time: currentTime,
                                duration,
                                playing: false
                            })
                        }}
                        onEnded={() => {
                            setVideoPlaying(false)

                            onPlaybackChange?.({
                                time: duration,
                                duration,
                                playing: false
                            })
                        }}
                        onDuration={setDuration}
                        onProgress={progress => {
                            const time = progress.playedSeconds

                            setCurrentTime(time)

                            onPlaybackChange?.({
                                time,
                                duration,
                                playing: videoPlaying
                            })
                        }}
                    />
                </div>
            )}

            {!videoReady && thumbnail && (
                <img
                    src={thumbnail}
                    alt=''
                    className={styles.poster}
                />
            )}

            {duration > 0 && (
                <div className={styles.duration}>
                    {formatVideoTime(currentTime)}
                </div>
            )}

            <div
                className={styles.controls}
                data-prevent-open
                onClick={toggleVideo}
            >
                {videoPlaying ? (
                    <IconPostPauseOutline />
                ) : (
                    <IconPostPlayOutline />
                )}
            </div>
        </div>
    )
}
/* import { useRef, useState } from 'react'

import { IconPostPlayOutline } from 'assets/svg/sprite'
import VideoPlayer from 'features/VideoPlayer/VideoPlayer'
import { formatVideoTime } from 'lib/dayjs'

import styles from './mediaItemVideo.module.scss'

interface Props {
    url: string
    thumbnail?: string
    duration?: number
    videoId?: string
    videoUserId?: string
    onPlayingChange?: (playing: boolean) => void
}

export const MediaItemVideo = ({
    url,
    thumbnail,
    duration,
    videoId,
    videoUserId,
    onPlayingChange
}: Props) => {
    const [playing, setPlaying] = useState(false)
    const [hasInteracted, setHasInteracted] = useState(false)
    const [suppressFirstPlayerIcon, setSuppressFirstPlayerIcon] = useState(true)
const playingRef = useRef(false)
const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = event.currentTarget.getBoundingClientRect()

    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    const centerX = rect.width / 2
    const centerY = rect.height / 2

    const clickedPlayArea =
        Math.abs(x - centerX) <= 40 &&
        Math.abs(y - centerY) <= 40

    if (!clickedPlayArea) {
        return
    }

    const nextPlaying = !playingRef.current

    // Parent sidebar reacts immediately.
    onPlayingChange?.(nextPlaying)

    setHasInteracted(true)

    // If we're clicking while already playing,
    // this is the first real pause interaction.
    // From this point on, allow VideoPlayer's
    // normal transient play/pause icons.
    if (playingRef.current) {
        setSuppressFirstPlayerIcon(false)
    }

    event.stopPropagation()
}

    return (
<div
    className={`${styles.wrapper} ${
        suppressFirstPlayerIcon
            ? styles.suppressPlayerIcon
            : ''
    }`}
    onClick={handleClick}
>
            <VideoPlayer
                url={url}
                poster={thumbnail}
                minimized={false}
                showControls={false}
                controlsDisabled={false}
                duration={duration}
                isActive
                pauseWhenPreviewClosed={false}
                shouldTrackPlayed={!!videoId && !!videoUserId}
                videoId={videoId}
                videoUserId={videoUserId}
onPlaybackState={state => {
    playingRef.current = state.playing
    setPlaying(state.playing)

    if (state.playing) {
        setHasInteracted(true)
    }
}}
            />

            {!hasInteracted && !playing && (
                <div className={styles.initialPlayIcon}>
                    <IconPostPlayOutline />
                </div>
            )}

            {typeof duration === 'number' && duration > 0 && (
                <div className={styles.duration}>
                    {formatVideoTime(duration)}
                </div>
            )}
        </div>
    )
} */